import type { MultiSelectFilterOption } from '@openx/components-filters/lib/FastFilters/MultiSelectFilterDropdown';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery';

export const useSensitiveCategoriesOptionsFetch = () => {
  const { data: { optionsByPath = [] } = {}, loading } = useOptionsByPathQuery({
    variables: {
      path: 'deal.custom_pricing_ad_category',
    },
  });

  const categoryOptions = useMemo<MultiSelectFilterOption[]>(() => {
    return optionsByPath.map(option => ({
      value: String(option?.id),
      label: String(option?.name),
    }));
  }, [optionsByPath]);

  return {
    categoryOptions,
    isCategoryOptionsLoading: loading,
  };
};
